import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import cx from 'classnames';
import { saveAs } from 'file-saver';
import { format } from 'date-fns';

import {
  TeacherEvaluationPageProvider,
  TeacherEvaluationPageActions as actions,
  TeacherEvaluationPageContext,
  filteredStudentsSelector,
  activeSubmissionSelector,
  activeStudentSelector,
  assignmentDataSelector,
} from './context';
import _, { isUndefined } from 'lodash';
import { Swiper as SwiperContainer, SwiperSlide } from 'swiper/react';
import Swiper from 'swiper';
import { Mousewheel } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import Select, { Option } from 'rc-select';
import { useLocalStorage, useLockBodyScroll } from 'react-use';
import qs from 'query-string';
import { CommentEditor } from './components/CommentEditor';
import { StudentFilter } from './components/StudentFilter';
import { StudentSelector } from './components/StudentSelector';
import { CourseCascader, type CourseCascaderProps } from './components/CourseCascader';
import { useStoreContext } from '../../factorys/useStoreContext';
import { IdentityContext } from '../App/identity.context';
import { Loader } from '../../components/Loader';
import { getAssignmentMediaTypeHint, getMediaFileInfoFromUrl, resolveMediasImageFirst, sortMediasImageFirst, type MediaWithUrl } from '../../utils/media';
import { AssignmentMediaPreview } from '../../components/AssignmentMediaPreview';
import { Transcript } from '../Transcript';
import { GetUserAssignmentGroupsDocument, SubmissionStatus } from '../../services/graphql/types/graphql';
import { useQueryState } from '../../hooks/useQueryState';
import { useQuery } from '@apollo/client';

const AssignmentInfo = (): JSX.Element => {
  const { state } = useContext(TeacherEvaluationPageContext);
  return (
    <div className="assignment-info__container flex flex-col tracking-[0.1em] text-white">
      <div className="flex items-center border-b">
        <div className="w-[12px] shrink-0 text-[12px] leading-[16px] opacity-60">科目</div>
        <div className="min-w-0 pl-[13px] text-[20px] leading-[50px] truncate">
          {state.assignmentData?.assignment.course.name}
        </div>
      </div>
      <div className="flex items-center">
        <div className="w-[12px] shrink-0 text-[12px] leading-[16px] opacity-60">作业</div>
        <div className="min-w-0 pl-[13px] text-[16px] leading-[50px] truncate">
          {state.assignmentData?.assignment.name}
        </div>
      </div>
    </div>
  );
};

const GradeArea = (): JSX.Element => {
  const {
    state,
    state: { activeStudentIndex, assignmentData },
  } = useContext(TeacherEvaluationPageContext);
  const { currentClassId, currentIdentity } = useStoreContext(IdentityContext);

  const activeStudent = useMemo(
    () => activeStudentSelector(state, currentIdentity!.identity),
    [currentIdentity, state],
  );
  const activeSubmission = useMemo(
    () => activeSubmissionSelector(state, currentIdentity!.identity),
    [currentIdentity, state],
  );

  const [expanded, setExpanded, remove] = useLocalStorage('teach-evaluation-page--expanded', false);

  if (!expanded || !activeSubmission) {
    return (
      <div
        className="flex flex-col items-center justify-center mr-6"
        onClick={() => setExpanded(!expanded)}
      >
        <div className="w-[40px] h-[40px] bg-[#A6A6A6] rounded-full flex items-center justify-center self-start">
          <svg
            className="rotate-180"
            width="12"
            height="14"
            viewBox="0 0 12 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.38303 6.60824L1.76946 0.121307C1.71525 0.0437501 1.63031 0 1.54176 0H0.144862C0.0237849 0 -0.0430785 0.153125 0.0310133 0.256534L4.8271 7L0.0310133 13.7435C0.0143278 13.7669 0.00397475 13.7951 0.00113778 13.8247C-0.00169918 13.8543 0.0030946 13.8842 0.0149708 13.9109C0.0268469 13.9377 0.0453263 13.9603 0.0682961 13.976C0.0912659 13.9917 0.117799 14.0001 0.144862 14H1.54176C1.63031 14 1.71525 13.9543 1.76946 13.8787L6.38303 7.39375C6.54748 7.16108 6.54748 6.83892 6.38303 6.60824ZM11.8767 6.60824L7.26309 0.121307C7.20888 0.0437501 7.12395 0 7.0354 0H5.6385C5.51742 0 5.45056 0.153125 5.52465 0.256534L10.3207 7L5.52465 13.7435C5.50796 13.7669 5.49761 13.7951 5.49477 13.8247C5.49194 13.8543 5.49673 13.8842 5.50861 13.9109C5.52048 13.9377 5.53896 13.9603 5.56193 13.976C5.5849 13.9917 5.61143 14.0001 5.6385 14H7.0354C7.12395 14 7.20888 13.9543 7.26309 13.8787L11.8767 7.39375C12.0411 7.16108 12.0411 6.83892 11.8767 6.60824Z"
              fill="black"
              fillOpacity="0.65"
            />
          </svg>
        </div>
        <div className="mt-[3px] text-[#A6A6A6]">成 绩</div>
      </div>
    );
  }

  return (
    <div
      className="grade-area__container bg-[#4D4D4D] rounded-[20px] mr-6"
    >
      <header className="bg-[#A6A6A6] px-[18px] flex items-center">
        <div>成 绩</div>
        <svg
          className="ml-auto relative"
          onClick={() => setExpanded(!expanded)}
          width="12"
          height="14"
          viewBox="0 0 12 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.38303 6.60824L1.76946 0.121307C1.71525 0.0437501 1.63031 0 1.54176 0H0.144862C0.0237849 0 -0.0430785 0.153125 0.0310133 0.256534L4.8271 7L0.0310133 13.7435C0.0143278 13.7669 0.00397475 13.7951 0.00113778 13.8247C-0.00169918 13.8543 0.0030946 13.8842 0.0149708 13.9109C0.0268469 13.9377 0.0453263 13.9603 0.0682961 13.976C0.0912659 13.9917 0.117799 14.0001 0.144862 14H1.54176C1.63031 14 1.71525 13.9543 1.76946 13.8787L6.38303 7.39375C6.54748 7.16108 6.54748 6.83892 6.38303 6.60824ZM11.8767 6.60824L7.26309 0.121307C7.20888 0.0437501 7.12395 0 7.0354 0H5.6385C5.51742 0 5.45056 0.153125 5.52465 0.256534L10.3207 7L5.52465 13.7435C5.50796 13.7669 5.49761 13.7951 5.49477 13.8247C5.49194 13.8543 5.49673 13.8842 5.50861 13.9109C5.52048 13.9377 5.53896 13.9603 5.56193 13.976C5.5849 13.9917 5.61143 14.0001 5.6385 14H7.0354C7.12395 14 7.20888 13.9543 7.26309 13.8787L11.8767 7.39375C12.0411 7.16108 12.0411 6.83892 11.8767 6.60824Z"
            fill="black"
            fillOpacity="0.65"
          />
        </svg>
      </header>
      <div className="grade-area__body" tabIndex={0} role="region" aria-label="评分与 AI 评价">
        <AssignmentInfo />
        <div className="text-white">
          {activeSubmission.createAt && <div>提交时间： {format(+activeSubmission.createAt, 'yyyy-MM-dd HH:mm:ss')}</div>}
          {activeSubmission.updateAt && <div>最后修改时间： {format(+activeSubmission.updateAt, 'yyyy-MM-dd HH:mm:ss')}</div>}
        </div>
        <div>
          {currentIdentity?.identity === 'teacher' && (
            <CommentEditor key={`${activeSubmission.submissionId}:${currentIdentity.identity}`} artworkId={activeSubmission.artworks?.[0]?.artworkId}></CommentEditor>
          )}

          {currentIdentity?.identity === 'ta' &&
            ([
              SubmissionStatus.Unsubmitted,
              SubmissionStatus.Submitted,
              SubmissionStatus.TaApproved,
              SubmissionStatus.ChangeRequested,
              SubmissionStatus.Completed,
              SubmissionStatus.CompletedButNoGrade,
            ].includes(activeSubmission.submissionStatus) ? (
              <CommentEditor key={`${activeSubmission.submissionId}:${currentIdentity.identity}`} artworkId={activeSubmission.artworks?.[0]?.artworkId}></CommentEditor>
            ) : (
              <div className="text-white text-3xl w-full h-full flex items-start justify-center py-20">
                等待学生提交
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

const AssignmentMediaNavButton = ({
  direction,
  onClick,
  disabled,
}: {
  direction: 'prev' | 'next';
  onClick: () => void;
  disabled: boolean;
}) => (
  <button
    type="button"
    aria-label={direction === 'prev' ? '上一张' : '下一张'}
    className={cx(
      'assignment-media-nav',
      direction === 'prev' ? 'assignment-media-nav--prev' : 'assignment-media-nav--next',
      disabled && 'assignment-media-nav--disabled',
    )}
    onClick={onClick}
    disabled={disabled}
  >
    <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 2L2 10L10 18"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </button>
);

const useResolvedMedias = (rawMedias: MediaWithUrl[]) => {
  const mediaKey = useMemo(
    () => rawMedias.map((media) => media.mediaId ?? media.url).join('|'),
    [rawMedias],
  );
  const [medias, setMedias] = useState(() => sortMediasImageFirst(rawMedias));

  useEffect(() => {
    let cancelled = false;
    resolveMediasImageFirst(rawMedias).then((sorted) => {
      if (!cancelled) {
        setMedias(sorted);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [mediaKey, rawMedias]);

  return medias;
};

const collectStudentMedias = (
  submissions?: Array<{ artworks?: Array<{ medias?: MediaWithUrl[] | null } | null> | null }>,
): MediaWithUrl[] =>
  submissions?.flatMap(
    (submission) =>
      submission.artworks?.flatMap((artwork) => artwork?.medias ?? []) ?? [],
  ) ?? [];

const AssignmentCard = ({
  className,
  rawMedias,
  mediaResetKey,
}: {
  className?: string;
  rawMedias: MediaWithUrl[];
  mediaResetKey: string;
}): JSX.Element => {
  const {
    state,
    state: { activeStudentIndex, showTranscriptPreview },
    dispatch,
    toggleStarStatus,
  } = useContext(TeacherEvaluationPageContext);
  const { currentClass, currentSchool, currentIdentity } = useStoreContext(IdentityContext);
  const role = currentIdentity!.identity;
  const filteredStudent = useMemo(
    () => filteredStudentsSelector(state, currentIdentity?.identity),
    [state.submissionFilter, state.sortBy, state.assignmentData, currentIdentity?.identity, role],
  );

  const currentSubmission = useMemo(() => activeSubmissionSelector(state, role), [state]);

  const artworkId = useMemo(() => currentSubmission?.artworks[0]?.artworkId, [currentSubmission]);
  const isStaredRemote = useMemo(
    () =>
      currentSubmission?.artworks[0]?.tags?.some((tag) => tag.name === 'internal--star') ?? false,
    [currentSubmission],
  );
  const [isStaredLocal, setIsStarLocal] = useState<boolean | undefined>(undefined);
  const isStared = isStaredLocal ?? isStaredRemote ?? false;

  useEffect(() => {
    setIsStarLocal(undefined);
  }, [currentSubmission?.submissionId, artworkId, isStaredRemote]);

  const toggleStar = async () => {
    if (!currentSubmission || !artworkId) {
      return;
    }

    const nextStarred = !isStared;
    setIsStarLocal(nextStarred);

    try {
      await toggleStarStatus(currentSubmission.submissionId, artworkId, isStared);
      setIsStarLocal(undefined);
    } catch (error) {
      setIsStarLocal(undefined);
      console.error(error);
    }
  };
  const medias = useResolvedMedias(rawMedias);
  const [activeMediaIndex, setActiveMediaIndex] = useState(0);
  const currentMedia = medias[activeMediaIndex];

  useEffect(() => {
    setActiveMediaIndex(0);
  }, [mediaResetKey]);

  const canNavigateMedia = medias.length > 1;

  const saveFile = () => {
    const mediaUrl = currentMedia?.url.replace('http://', 'https://') ?? '';
    if (!mediaUrl) {
      return;
    }
    const { ext, type } = getMediaFileInfoFromUrl(mediaUrl);
    const fileExt = ext ?? (type === 'video' ? 'mp4' : 'bin');
    saveAs(
      mediaUrl,
      `${currentSchool?.name}-${currentClass?.name}-${filteredStudent[activeStudentIndex].user.name}.${fileExt}`,
    );
  };

  return (
    <div className="flex flex-col flex-1 w-full h-full justify-center">
      {role === 'teacher' && (
        <div className="flex">
          <svg
            // className='self-end'
            onClick={toggleStar}
            width="15"
            height="14"
            viewBox="0 0 15 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.5 0L9.98633 4.07786L14.6329 5.18237L11.523 8.80714L11.9084 13.5676L7.5 11.73L3.09161 13.5676L3.47703 8.80714L0.367076 5.18237L5.01367 4.07786L7.5 0Z"
              fill={isStared ? 'red' : '#C4C4C4'}
            />
          </svg>
          <div className="w-[15px] h-[14px] ml-[5px]" onClick={saveFile}>
            <svg
              viewBox="0 0 64 64"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              role="img"
              preserveAspectRatio="xMidYMid meet"
              fill="#c4c4c4"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path d="M32 2C15.432 2 2 15.432 2 32s13.432 30 30 30s30-13.432 30-30S48.568 2 32 2zm0 47L16 33.695h10.857V15h10.285v18.695H48L32 49z"></path>
              </g>
            </svg>
          </div>
        </div>
      )}
      <div className={cx('relative w-full', className)}>
        <div className="assignment-media-viewer relative h-full w-full">
          {currentMedia ? (
            <AssignmentMediaPreview
              url={currentMedia.url.replace('http://', 'https://')}
              thumbnail={false}
              embedded
              mediaTypeHint={getAssignmentMediaTypeHint(
                currentMedia.url.replace('http://', 'https://'),
                'full',
              )}
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center text-xl text-white/70">
              已提交，暂无媒体文件
            </div>
          )}
          {medias.length > 0 ? (
            <div className="assignment-media-pagination">
              {activeMediaIndex + 1} / {medias.length}
            </div>
          ) : null}
        </div>
        {canNavigateMedia ? (
          <>
            <AssignmentMediaNavButton
              direction="prev"
              disabled={activeMediaIndex === 0}
              onClick={() => setActiveMediaIndex((index) => Math.max(index - 1, 0))}
            />
            <AssignmentMediaNavButton
              direction="next"
              disabled={activeMediaIndex >= medias.length - 1}
              onClick={() =>
                setActiveMediaIndex((index) => Math.min(index + 1, medias.length - 1))
              }
            />
          </>
        ) : null}
      </div>
    </div>
  );
};

const AssignmentSelector = (): JSX.Element => {
  const {
    state,
    state: { activeStudentIndex, showTranscriptPreview, sortBy, submissionFilter },
    dispatch,
  } = useContext(TeacherEvaluationPageContext);
  const { currentIdentity } = useStoreContext(IdentityContext);
  const filteredStudent = useMemo(
    () => filteredStudentsSelector(state, currentIdentity?.identity),
    [currentIdentity, state.submissionFilter, state.sortBy, state.assignmentData],
  );
  const filteredStudentKey = useMemo(
    () => filteredStudent.map((student) => student.userId).join(','),
    [filteredStudent],
  );

  const [swiper, setSwiper] = useState<Swiper | null>(null);
  const ignoreSlideChangeRef = useRef(false);

  useEffect(() => {
    if (!swiper) {
      return;
    }

    ignoreSlideChangeRef.current = true;
    swiper.slideTo(Math.min(activeStudentIndex, Math.max(filteredStudent.length - 1, 0)), 0);
    swiper.update();

    const timer = window.setTimeout(() => {
      ignoreSlideChangeRef.current = false;
    }, 0);

    return () => window.clearTimeout(timer);
  }, [activeStudentIndex, swiper, filteredStudentKey, sortBy, submissionFilter, filteredStudent.length]);

  if (filteredStudent.length === 0 && submissionFilter !== 'all') {
    return (
      <div className="flex items-center justify-center text-xl w-full h-full text-white/70">
        {submissionFilter === 'pending' ? '暂无待评价作业' : '暂无星标作业'}
      </div>
    );
  }

  return (
    <SwiperContainer
      key={`${submissionFilter}-${filteredStudentKey}`}
      centeredSlides
      direction={'vertical'}
      modules={[Mousewheel]}
      mousewheel={{ forceToAxis: true, releaseOnEdges: true, thresholdDelta: 30, thresholdTime: 300 }}
      slidesPerView={1}
      spaceBetween={0}
      className="assignment-selector__container"
      onSwiper={(swiperInstance) => {
        ignoreSlideChangeRef.current = true;
        setSwiper(swiperInstance);
        window.setTimeout(() => {
          ignoreSlideChangeRef.current = false;
        }, 0);
      }}
      onSlideChange={(swiper) => {
        if (ignoreSlideChangeRef.current) {
          return;
        }
        dispatch(actions.setActiveStudentIndex(swiper.activeIndex));
      }}
    >
      {filteredStudent.map((dStudent) => {
        const rawMedias = collectStudentMedias(dStudent.submissions);
        const mediaResetKey = `${dStudent.userId}-${rawMedias
          .map((media) => media.mediaId ?? media.url)
          .join('|')}`;

        if (!dStudent.submissions || dStudent.submissions.length === 0) {
          return (
            <SwiperSlide key={`assignment-selector-${dStudent.userId}`}>
              <div className="flex items-center justify-center text-3xl w-full text-white">
                作业未提交
              </div>
            </SwiperSlide>
          );
        }

        if (showTranscriptPreview) {
          return (
            <SwiperSlide key={`assignment-selector-${dStudent.userId}`}>
              <Transcript submissionId={dStudent.submissions?.[0]?.submissionId}></Transcript>
            </SwiperSlide>
          );
        }

        return (
          <SwiperSlide key={`assignment-selector-${dStudent.userId}`} className="!h-full">
            <AssignmentCard
              className="item"
              rawMedias={rawMedias}
              mediaResetKey={mediaResetKey}
            />
          </SwiperSlide>
        );
      })}
    </SwiperContainer>
  );
};

const GroupSelector: React.FC = () => {
  const { currentSchoolId, setCurrentSchoolId, setCurrentClassId, currentClass } =
    useStoreContext(IdentityContext);
  const { data: userAssignmentGroupsData } = useQuery(GetUserAssignmentGroupsDocument);
  const {
    state: { assignmentData },
    currentGroupId,
    setCurrentGroupId,
    dispatch: dispatchTeacherEvaluationPage,
    toggleStarStatus,
  } = useContext(TeacherEvaluationPageContext);

  const isGroupAssignment = useMemo(
    () => assignmentData?.assignment.isGroupAssignment,
    [assignmentData],
  );
  const availableIdentities = useMemo(
    () =>
      userAssignmentGroupsData?.userAssignmentGroups.filter(
        (uag) => uag.assignmentGroup.schoolId === currentSchoolId,
      ) || [],
    [userAssignmentGroupsData, currentSchoolId],
  );

  const handleGroupChange = (value: string) => {
    setCurrentGroupId?.(value);
  };

  if (!isGroupAssignment || !userAssignmentGroupsData) {
    return <></>;
  }

  return (
    <Select
      className="ml-[40px]"
      style={{ width: 'auto', fontSize: '18px' }}
      value={currentGroupId}
      onChange={handleGroupChange}
      dropdownMatchSelectWidth={200}
      disabled={availableIdentities?.length === 1}
      // showArrow={availableIdentities?.length !== 1}
      dropdownClassName="z-[10000]"
    >
      {availableIdentities?.map((c, i) => {
        return <Option key={c.assignmentGroup.assignmentGroupId}>{c.assignmentGroup.name}</Option>;
      })}
    </Select>
  );
};

export const TeacherEvaluationPageContent: React.FC = () => {
  const navigate = useNavigate();
  const { state, dispatch, toggleStarStatus } = useContext(TeacherEvaluationPageContext);
  const { userIdentities, currentIdentity, availableClasses, currentClassId } =
    useStoreContext(IdentityContext);
  const role = currentIdentity?.identity;

  const [courseId, setCourseId] = useQueryState('courseId', '');
  const [lessonId, setLessonId] = useQueryState('lessonId', '');
  const [assignmentId, setAssignmentId] = useQueryState('assignmentId', '');
  const [classIdFromQuery] = useQueryState('classId', '');

  const handleBackHome = useCallback(() => {
    if (currentIdentity?.identity === 'ta') {
      navigate(
        `/gradebook?${qs.stringify({ classId: classIdFromQuery || currentClassId })}`,
      );
      return;
    }
    navigate('/');
  }, [classIdFromQuery, currentClassId, currentIdentity?.identity, navigate]);

  // Function to update all URL params at once to avoid race conditions
  const setAllQueryParams = useCallback((params: { courseId: string; lessonId: string; assignmentId: string }) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('courseId', params.courseId);
    searchParams.set('lessonId', params.lessonId);
    searchParams.set('assignmentId', params.assignmentId);
    navigate(`${window.location.pathname}?${searchParams.toString()}`, { replace: true });
  }, [navigate]);

  const assignmentData = useMemo(() => assignmentDataSelector(state), [state]);
  const isGroupAssignment = assignmentData?.assignment.isGroupAssignment;

  useLockBodyScroll();

  return (
    <>
      <button
        type="button"
        className="absolute top-[37px] right-[40px] z-20 rounded-full border border-[#979797] px-4 py-1 text-[16px] text-[#979797] transition-colors hover:border-white hover:text-white"
        onClick={handleBackHome}
      >
        返回主界面
      </button>
      <div className="teacher-evaluation-course-nav flex ml-auto text-[18px] absolute top-[37px] left-[200px] right-[200px] text-[#979797] z-10">
        <CourseCascader 
          setAllQueryParams={setAllQueryParams}
          isGroupAssignment={isGroupAssignment}
        >
          <GroupSelector></GroupSelector>
        </CourseCascader>
      </div>
      {!assignmentData ? (
        <div className="flex items-center justify-center h-screen bg-gray-900 teacher-evaluation-page__container">
          <div className="text-center text-white">
            <div className="text-3xl mb-4">请选择作业</div>
            <div className="text-xl text-gray-400">
              {isGroupAssignment 
                ? '使用上方的级联选择器选择课程、课次和作业'
                : '使用上方的级联选择器依次选择学期、班级、课程、课次和作业'}
            </div>
          </div>
        </div>
      ) : (
        <div className="teacher-evaluation-page__container">
          <div className="class-nav"></div>
          <StudentSelector></StudentSelector>
          <div className="assignment-nav">
            <AssignmentSelector />
          </div>
          <div className={cx('grader')}>
            <GradeArea />
          </div>
          <StudentFilter></StudentFilter>
        </div>
      )}
    </>
  );
};

const TeacherEvaluationPage = (): JSX.Element => {
  return (
    <TeacherEvaluationPageProvider>
      <TeacherEvaluationPageContent />
    </TeacherEvaluationPageProvider>
  );
};

export default TeacherEvaluationPage;
